import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="headexpd"
export default class extends Controller {

  static targets = ["head", "btn"]

  connect() {}

  expand() {
    this.headTarget.classList.toggle('open');
    document.querySelector('#primary-navigation').classList.toggle('open');
    this.btnTarget.classList.toggle('open');
  }
}
